// extracted by mini-css-extract-plugin
export default {"dotContainer":"kN5KC","dot":"qY44e","previous":"_Hl1Y","active":"yna9V"};